import { Logger, useVSFContext } from '@vue-storefront/core';

type GetSlugRedirectsType = (
  slug: string,
  host: string,
  origin: string,
  websiteCountry: string
) => Promise<Record<string, string>>;

export const useLanguageSelection = (): {
  getSlugRedirects: GetSlugRedirectsType;
} => {
  const context = useVSFContext();

  const getSlugRedirects: GetSlugRedirectsType = async (slug, host, origin, websiteCountry) => {
    Logger.debug('useLanguageSelection/getSlugRedirects called');
    return context.$novulo.api.getSlugRedirects(slug, host, origin, websiteCountry);
  };

  return {
    getSlugRedirects
  };
};
